(function () {
  var ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"' +
    ' class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"' +
    ' stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M3 9V4h5"/>' +
    '<path d="M21 9V4h-5"/>' +
    '<path d="M3 15v5h5"/>' +
    '<path d="M21 15v5h-5"/>' +
    '<path d="M12 8l4 2.3v4.4L12 17l-4-2.3V10.3L12 8z"/>' +
    '<path d="M12 8v9"/>' +
    '<path d="M8 10.3l4 2.4 4-2.4"/>' +
    '</svg>';

  function addPillButton(xrBtn) {
    var viewer = document.querySelector('.product__media-gallery-viewer');
    if (!viewer) return;
    if (viewer.querySelector('.product__ar-pill-btn')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product__ar-pill-btn';
    btn.setAttribute(
      'aria-label',
      xrBtn.getAttribute('aria-label') || 'Voir en réalité augmentée'
    );
    btn.innerHTML = ICON_SVG + '<span>3D</span>';
    btn.addEventListener('click', function () {
      xrBtn.click();
    });
    viewer.appendChild(btn);
  }

  function init() {
    var xrBtn = document.querySelector('[data-shopify-xr]');
    if (!xrBtn) return;

    var tryAdd = function () {
      if (!xrBtn.hasAttribute('data-shopify-xr-hidden')) {
        addPillButton(xrBtn);
      }
    };

    var observer = new MutationObserver(tryAdd);
    observer.observe(xrBtn, {
      attributes: true,
      attributeFilter: ['data-shopify-xr-hidden'],
    });

    tryAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
